import React, { useCallback } from 'react';
import { Modal } from '@/pages/common';
import * as Styles from './useBlockedWindowModal.styles';
import { Button, IconRefreshPage } from 'gatorcomponents';
import useLocale from '../useLocale';
import { getCookie } from '@/utils/Application/cookies';
import { POPUP_BLOCKED_ORIGIN } from './useBlockedWindowModal.enum';

export const useBlockedWindowModal = () => {
  const popupBlocked = getCookie('popupBlocked');

  const setPopupBlockedModalOnCookie = useCallback(({ origin = POPUP_BLOCKED_ORIGIN.DEFAULT }) => {
    document.cookie = `popupBlocked=${origin}; path=/;`;
  }, []);

  const removePopupBlockedModalFromCookie = useCallback(() => {
    document.cookie = 'popupBlocked=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }, []);

  const handleOpen = ({ url, closeModal }) => {
    window.open(url, '_blank');
    closeModal && closeModal();
  };

  const { useBlockedWindowModal: useBlockedWindowModalLocale } = useLocale();

  const renderBlockedWindowModal = ({
    url,
    closeModal,
  }) => (
    <Modal
      disablePadding
      onClose={closeModal}
    >
      <Styles.RefreshPageWrapper>
        <Styles.IconWrapper>
          <IconRefreshPage size="lg" color="primaryExtraDark" />
        </Styles.IconWrapper>

        <Styles.Description>
          {useBlockedWindowModalLocale.description}
        </Styles.Description>

        <Button
          label={useBlockedWindowModalLocale.cta}
          onClick={() => handleOpen({ url, closeModal })}
          size="large"
        />
      </Styles.RefreshPageWrapper>
    </Modal>
  );

  const useBlockedWindowModalData = {
    renderBlockedWindowModal,
    setPopupBlockedModalOnCookie,
    removePopupBlockedModalFromCookie,
    popupBlocked,
  };

  return useBlockedWindowModalData;
};

export default useBlockedWindowModal;
